{
  "en": {
    "dashboard": {
      "greetings": {
        "afternoon": "Good afternoon {first_name}",
        "evening": "Good evening {first_name}",
        "morning": "Good morning {first_name}",
        "night": "Good night {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "You have no open items right now.",
        "caught_up_title": "You're all caught up",
        "completed_count": "{count} completed",
        "due_before": "Before {date}",
        "journey_no_active_subtitle": "This unit has not started its journey yet.",
        "journey_no_active_title": "No active milestone",
        "journey_select_unit_subtitle": "Choose a unit above to view its journey.",
        "journey_select_unit_title": "Select a unit",
        "journey_title": "Your journey",
        "open_action": "Open",
        "previous_label": "Previous milestones",
        "progress_completed": "{completed} / {total} completed",
        "show_less": "Show less",
        "show_more_tasks": "Show {count} more task | Show {count} more tasks",
        "status_active": "In progress",
        "status_completed": "Completed",
        "status_planned": "Planned",
        "todo_now_title": "What to do now",
        "upcoming_more": "{count} more upcoming milestones"
      },
      "titles": {
        "activityFeed": "Activity Feed",
        "assignedTasks": "My Tasks",
        "newsFeed": "News Feed",
        "ongoingTickets": "Ongoing",
        "openTickets": "Open",
        "progress": "Progress",
        "tickets": "Conversations",
        "totalTickets": "All conversations",
        "unreadTickets": "Unread",
        "yourAssignedTickets": "Assigned to you"
      }
    }
  }
}
